import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import 'leaflet/dist/leaflet.css';

import Carosel from '../../components/home/carosel';
import Services from '../../components/home/services';
import Paket from '../../components/home/paket';
import Mitra from '../../components/home/mitra';
import Peta from '../../components/home/peta';
import KomponenDashboard from '../../components/Dashboard/dashboard';
import Footer from '../../components/footer/index';
import Gallery from '../../components/home/gallery';
import News from '../../components/home/berita';
import { useDarkMode } from '../../components/darkmode/DarkModeContext';
import { useAuth } from '../auth/AuthContext';
import BusinessSolutions from '../../components/home/internet-business';
import SubscriptionSteps from '../../components/home/tata_cara_berlangganan';
import  CustomerChat from '../chat/CustomerChat';
import L from 'leaflet';

// Fix for default markers in react-leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

const Dashboard = () => {
  // const [currentSlide, setCurrentSlide] = useState(0);
  // const [emailSubscription, setEmailSubscription] = useState('');
  
  // Use auth context to track authentication state
  const { user, isAuthenticated, loading, refreshUser } = useAuth(); // Tambahkan refreshUser
  const navigate = useNavigate();
  
  // Use dark mode from context
  const { isDarkMode } = useDarkMode();

  // Helper function untuk mendapatkan data user yang konsisten
  const getActualUserData = () => {
    if (!user) return null;
    
    // Handle nested user structure
    if (user.user && typeof user.user === 'object') {
      if (user.user.profile && typeof user.user.profile === 'object') {
        return user.user.profile;
      }
      return user.user;
    }
    
    // Handle direct profile structure
    if (user.profile && typeof user.profile === 'object' && !user.email && !user.fullName) {
      return user.profile;
    }
    
    // Handle direct user data
    return user;
  };

  const userData = getActualUserData();

  // Monitor authentication state and redirect if needed
  useEffect(() => {
    // console.log('Dashboard auth state:', { 
    //   isAuthenticated, 
    //   loading,
    //   user: userData ? { 
    //     email: userData.email, 
    //     name: userData.fullName || userData.name 
    //   } : null 
    // });

    // Jika user authenticated tapi data user tidak lengkap, refresh
    if (isAuthenticated && userData && (!userData.email || !userData.fullName)) {
      // console.log('User data incomplete, refreshing...');
      refreshUser();
    }

    // If not loading and not authenticated, redirect to home
    if (!loading && !isAuthenticated) {
      // console.log('User logged out, redirecting to home');
      navigate('/', { replace: true });
    }
  }, [isAuthenticated, loading, navigate, userData, refreshUser]);

  // Show loading while checking authentication
  if (loading) {
    return (
      <div className={`min-h-screen flex items-center justify-center ${
        isDarkMode ? 'bg-gray-900' : 'bg-gray-100'
      }`}>
        <div className="flex flex-col items-center space-y-4">
          <div className="animate-spin w-12 h-12 border-4 border-green-500 border-t-transparent rounded-full"></div>
          <p className={`${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
            Memuat dashboard...
          </p>
        </div>
      </div>
    );
  }

  // Only render dashboard content if user is authenticated
  if (!isAuthenticated) {
    return null; // Will redirect via useEffect
  }

  return (
    <div
      className={`min-h-screen flex flex-col font-sans w-full transition-colors duration-300`}
      style={{
        backgroundImage: `url('https://telnet.net.id/assets/bg.png')`,
        backgroundColor: isDarkMode ? '#111827' : ' #dfe4e0ff',
        color: isDarkMode ? '#F9FAFB' : '#111827',
        backgroundBlendMode: 'overlay' 
      }}
    >
      {/* Content */}

      <div className="pt-20">
        
        {/* Carousel */}
        <Carosel />
        
       <KomponenDashboard user={userData} />
        
        {/* Service Categories */}
        <Services />

        <BusinessSolutions />

        {/* Popular Packages */}
        <Paket />

        <SubscriptionSteps />

        <Gallery />

        <News />

        <div className="mb-16">
          <div className="text-center mb-8">
            <h2 className={`text-3xl font-bold mb-4 ${
              isDarkMode ? 'text-green-50' : 'text-gray-900'
            }`}>
              Area Cakupan Layanan
            </h2>
            <p className={isDarkMode ? 'text-gray-300' : 'text-gray-700'}>
              Kami terus memperluas jangkauan layanan ke seluruh wilayah Aceh
            </p>
          </div>
          <Peta />
        </div>
        
        {/* Partners */}
        <Mitra />
      </div>
      
      {/* Footer */}
      <Footer />
      <CustomerChat />
    </div>
  );
};

export default Dashboard;